import React, { useContext } from "react";
import "./Am.scss";
import MyContext from "../Context/MyContext";
import { CgClose } from "react-icons/cg";
import AttendanceForm from "./AttendanceForm/AttendanceForm";



const Am = () => {
  const { am, handleCloseModal } = useContext(MyContext);

  return (
    <>
      {am && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
       
             
              <CgClose className="close-icon" onClick={handleCloseModal} />
        
            <AttendanceForm />
          </div>
        </div>
      )}
    </>
  );
};

export default Am;
